import React, { useEffect, useState } from 'react';
import Button, { ButtonSize, ButtonType } from 'src/components/Button';
import styles from './CookiePopup.css';
import Cookies from 'js-cookie';
import TranslateMessage from '../../i18n/TranslateMessage';
import { useIntl } from "react-intl";

const AGREED_TO_USE_COOKIES_KEY = 'use-cookies';
const SAME_SITE_OPTION = { SameSite: 'Lax' };
const SECURE_OPTION = (window.location.protocol === 'https:' ? { secure: true } : {});
const OPTIONS = {
  ...SAME_SITE_OPTION,
  ...SECURE_OPTION,
};

export interface ICookiePopupProps {
  onCancel: () => void;
  onApply: () => void;
}

export const CookiePopup = (props: ICookiePopupProps) => {
  const intl = useIntl();
  const { onApply } = props;
  
  return (
    <div className={styles.container}>
      <div className={styles.body}>
        <div className={styles.header} tabIndex={2}>{TranslateMessage('MursionPortal.CookiePolicy.Header.CookiePolicy')}</div>
        <div className={styles.text}>
          {TranslateMessage('MursionPortal.CookiePolicy.Text.MursionUsesEssentialCookiesOnly')}
          {TranslateMessage('MursionPortal.CookiePolicy.Text.ForMoreInformation',
            {
              code : (word: string) => <a tabIndex={4} href='https://www.mursion.com/privacynotice/' target='_blank'> {word} </a>
            })}
        </div>
      </div>
      <div className={styles.footer}>
        <Button
          className={styles.okBtn}
          btnSize={ButtonSize.MEDIUM}
          btnType={ButtonType.BLUE}
          onClick={onApply}
          tabIndex={5}
          aria-label={intl.formatMessage({ id: "MursionPortal.Button.Ok" })}
        >
          {TranslateMessage('MursionPortal.Button.Ok')}
        </Button>
      </div>
    </div>
  );
};

const CookiePopupContainer = () => {

  const agreedToUseCookies = Cookies.get(AGREED_TO_USE_COOKIES_KEY);
  const [show, setShow] = useState<boolean>(agreedToUseCookies !== 'true');

  useEffect(() => {
    setShow(agreedToUseCookies !== 'true');
  }, [agreedToUseCookies]);

  if (!show) {
    return null;
  }

  // TODO: figure out if we really need that
  const onCancel = () => {
    Cookies.set(AGREED_TO_USE_COOKIES_KEY, 'false', OPTIONS);
    setShow(false);
  };

  const onApply = () => {
    Cookies.set(AGREED_TO_USE_COOKIES_KEY, 'true', OPTIONS);
    setShow(false);
  };

  return <CookiePopup onCancel={onCancel} onApply={onApply}/>;
};

export default CookiePopupContainer;